var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharacter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#00C7BE",
    fillOpacity: 0.14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1797_3141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7125 16.9688C35.3562 16.3687 34.7 16 34 16C33.3 16 32.6438 16.3687 32.2875 16.9688L26.2875 26.9688C25.9188 27.5875 25.9062 28.3562 26.2625 28.9812C26.6187 29.6062 27.2812 29.9937 28 29.9937H40C40.7188 29.9937 41.3875 29.6062 41.7375 28.9812C42.0875 28.3562 42.0812 27.5875 41.7125 26.9688L35.7125 16.9688ZM34 35.5V44.5C34 45.8813 35.1187 47 36.5 47H45.5C46.8813 47 48 45.8813 48 44.5V35.5C48 34.1187 46.8813 33 45.5 33H36.5C35.1187 33 34 34.1187 34 35.5ZM24 48C26.1217 48 28.1566 47.1571 29.6569 45.6569C31.1571 44.1566 32 42.1217 32 40C32 37.8783 31.1571 35.8434 29.6569 34.3431C28.1566 32.8429 26.1217 32 24 32C21.8783 32 19.8434 32.8429 18.3431 34.3431C16.8429 35.8434 16 37.8783 16 40C16 42.1217 16.8429 44.1566 18.3431 45.6569C19.8434 47.1571 21.8783 48 24 48Z",
    fill: "#00C7BE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1797_3141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacter);
export default __webpack_public_path__ + "static/media/character.f981e11403d2835b74da67e4b2e0ed58.svg";
export { ForwardRef as ReactComponent };